export const actionsModel = {
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    VIEW: 'VIEW'
}